<template>
  <v-snackbar
    :color='color'
    v-model='snacker' >
    {{ message }}
    <v-btn flat color="pink"
      @click.native="snackbar = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'VuexSnackbar',
  props: {
    successMessage: {type: String},
    errorMessage: {type: String},
    reqId: {type: String}
  },
  data () {
    return {
      message: null,
      snacker: false,
      color: null
    }
  },
  watch: {
    reqStatus () {
      if (this.reqStatus < 300) {
        this.message = this.successMessage
        this.color = 'success'
      } else {
        this.message = this.errorMessage
        this.color = 'danger'
      }
      this.snacker = true
    }
  },
  computed: {
    req () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    reqStatus () {
      return this.req.status
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// VuexSnackbar.vue?a4277492